<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.888 5.807A4 4 0 0 1 6.706 3h10.588a4 4 0 0 1 3.818 2.807l.667 2.132a3.88 3.88 0 0 1-.78 3.72V17a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-5.34a3.88 3.88 0 0 1-.778-3.72zM14.074 8.65 13.616 5h-3.234l-.457 3.651a2.09 2.09 0 1 0 4.147 0M8.366 5H6.705a2 2 0 0 0-1.908 1.403L4.13 8.536a1.898 1.898 0 1 0 3.695.801zm7.266 0 .425 3.403.117.934a1.898 1.898 0 1 0 3.695-.801l-.667-2.133A2 2 0 0 0 17.294 5z"
      fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
